<template>
  <div class="main-container-wrapper h" :style="{ 'margin-top': info }">
    <div class="main-container-wrapper">
      <div class="main-content flex-content-space-between">
        <div class="left-content">
          <img class="logoimg" alt="Vue logo" src="../assets/gwy.jpg" />
          <h1>全国一体化在线政务服务平台<br />国家文物局综合行政管理平台</h1>
        </div>
        <div class="right-content">
          <ul class="horizontal-ul">
            <a id="assist-open" href="javascript:" accesskey="g">无障碍阅读</a>
            <!-- <li> -->
            <!-- <a
              id="wzayd"
              title="盲人朋友在线浏览按住Alt+g键"
              href="javascript:"
              class="wzayd"
              accesskey="g"
              >无障碍阅读</a
            > -->
            <!-- <a id="wzayd" title="无障碍" class="wzayd"
                >无障碍阅读</a
              > -->
            <!-- </li> -->

            <li @click="runLogin">
              <a>登录</a>
              <!-- <a :href="jumpAddress + '?type=3'">登录</a> -->
            </li>
            <!-- <li>
              <a :href="jumpAddress + '?type=1'">法人登录</a>
            </li> -->
            <li class="split">|</li>
            <li>
              <el-dropdown>
                <span class="aaa">注册</span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item click="geren"
                    ><span @click="geren">个人注册</span></el-dropdown-item
                  >
                  <el-dropdown-item click="faren"
                    ><span @click="faren">法人注册</span></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </li>
          </ul>
          <el-input
            v-model="input"
            placeholder="请输入您要搜索的内容"
            class="input-with-select"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              size="small"
              @click="button"
            ></el-button>
          </el-input>
        </div>
      </div>
    </div>
    <!-- <el-dialog
      title=""
      :visible.sync="modal1"
      width="65%"
      :before-close="handleClose"
    >
      <Message></Message>
      <span slot="footer" class="dialog-footer">
        <el-button
          style="margin-right: 20px"
          type="primary"
          @click="runCrblogin"
          >确 定</el-button
        >

        <el-button @click="modal1 = false">取 消</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import { url, jumpAddress } from "../utils/axiosUrl";
import "./assist-master/dist/assist-entry.js";
// import Message from "../views/home/message.vue";
export default {
  name: "MainHeader",
  // components: { Message },
  data() {
    return {
      input: null,
      url: url,
      jumpAddress: jumpAddress,
      // modal1: false,
    };
  },
  props: ["info"],
  computed: {},
  mounted() {},
  methods: {
    button() {
      let design = this.$router.resolve({
        path: "/goverment-search-all",
        query: { queryInfo: this.input },
      });
      this.input = null;
      window.open(design.href, "_blank");
      // this.$router.push({
      //   path: "/goverment-search-all",
      //   query: { queryInfo: this.input },
      // });
    },
    runLogin() {
      window.open(this.jumpAddress);
      // this.modal1 = true;
    },
    // runCrblogin() {
    //   window.open(this.jumpAddress);
    //   this.modal1 = false;
    // },
    asyncOK() {},
    geren() {
      window.open(
        "http://ca.ncha.gov.cn:10000/am/register/personRegister.html?goto=http://ca.ncha.gov.cn:10000/am/oauth2/authorize?decision=Allow&service=initService&scope=all&response_type=code&client_id=ac2ab723a3884594&redirect_uri=http%3A%2F%2Fgl.ncha.gov.cn%3A8088%2F%23%2Flogin"
      );
      // this.$router.push({
      //   path: "/IndividualRegistration",
      //   query: {},
      // });
    },

    faren() {
      window.open(
        "http://ca.ncha.gov.cn:10000/am/register/legalRegister.html?goto=http://ca.ncha.gov.cn:10000/am/oauth2/authorize?decision=Allow&service=initService&scope=all&response_type=code&client_id=ac2ab723a3884594&redirect_uri=http%3A%2F%2Fgl.ncha.gov.cn%3A8088%2F%23%2Flogin"
      );
      // this.$router.push({
      //   path: "/RegisterLPStep",
      //   query: {},
      // });
    },
  },
};
</script>

<style scoped lang="less">
@import "../styles/theme";
.el-button--primary {
  background-color: #b71c1c;
  border-color: #b71c1c;
}
/deep/ .el-dialog__footer {
  text-align: center !important;
}
@keyframes mainHea {
  0% {
    margin-top: 0px;
  }
  100% {
    margin-top: 300px;
  }
}
.main-container-wrapper {
  background: @white;
  height: @height-header;
}
.main-content {
  padding-top: 10px;
}
.h {
  width: 1150px;
}
.left-content {
  height: @height-banner;
  h1 {
    display: inline-block;
    color: @theme-color;
    font-size: 20px;
    position: relative;
    top: -20px;
    left: 20px;
    line-height: 1.3;
  }
}
.right-content {
  height: @height-banner;
  ul {
    margin: 0.8rem 0;
    text-align: right;
  }
  li {
    display: inline-block;
    margin: 0 0 0 1.5rem;
    font-weight: 700;
    font-size: 16px;
  }
  .input-with-select {
    width: 24rem;
  }
  /deep/.el-input__inner:focus {
    border-color: @theme-color;
  }
  /deep/.el-input-group__append {
    background: #b71c1c;
    border-color: @theme-color;
    color: #ffffff;
  }
}
.aaa {
  font-size: 16px;
  color: black;
  cursor: pointer;
  margin-right: 3px;
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #b71c1c;
  background-color: #f8e8e8;
}
/deep/ .el-dialog__body {
  padding: 15px 20px;
}
/deep/ .el-dialog__header {
  padding: 10px 20px 10px;
}
.logoimg{
  width: 79px;
  height: 81px;
}
</style>
